<template>
  <div id="mask">
    
  </div>
</template>

<style lang="scss" scoped>
  #mask{
    position: fixed;
    z-index: 9;
    width: 100%;
    height: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    background-color: rgba(33,50,83,0.5);
  }
</style>
